/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react"
import { useEffect } from "react"

const ResumeExperience = (): any => {
	useEffect(() => {
		if (window.opener) window.opener.postMessage({ loginSuccess: true }, "*")
	}, [])
	return null
}

export default ResumeExperience
